export default __webpack_public_path__ + "static/media/project4.9ae52072.png";